import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  FireAlarmComponentDto,
  FireAlarmSystemComponent,
  FireAlarmSystemComponentDto
} from '@authority-labs/api-interfaces';
import { SelectFireAlarmComponentDialogComponent } from '@check-list/app/modules/fire-alarm-components/select-fire-alarm-component-dialog/select-fire-alarm-component-dialog.component';
import { EntitySelectorDialogService } from '@check-list/app/shared';

@Component({
  selector: 'authority-labs-fire-alarm-components',
  templateUrl: './fire-alarm-components.component.html',
  styleUrls: ['./fire-alarm-components.component.scss']
})
export class FireAlarmComponentsComponent implements OnInit {
  @Input() fireAlarmComponents: FireAlarmSystemComponentDto[];
  @Input() readonly: boolean;
  @Input() printPreview: boolean;
  @Output() dataChange: EventEmitter<FireAlarmSystemComponentDto[]> =
    new EventEmitter();

  displayedColumns = ['type', 'model', 'manufacture', 'notes'];

  constructor(
    private entitySelectorDialogService: EntitySelectorDialogService
  ) {}

  ngOnInit() {
    if (!(this.readonly || this.printPreview)) {
      this.displayedColumns.unshift('drag');
      this.displayedColumns.push('actions');
    }
  }

  drop(event: CdkDragDrop<FireAlarmSystemComponentDto[]>) {
    const prevIndex = this.fireAlarmComponents.findIndex(
      (d) => d === event.item.data
    );
    moveItemInArray(this.fireAlarmComponents, prevIndex, event.currentIndex);
    this.fireAlarmComponents = [...this.fireAlarmComponents];

    this.onChange();
  }

  addNew(
    fireAlarmComponent: FireAlarmSystemComponent = new FireAlarmSystemComponent()
  ): void {
    this.fireAlarmComponents = [
      ...this.fireAlarmComponents,
      fireAlarmComponent
    ];

    this.onChange();
  }

  addExisting(): void {
    this.entitySelectorDialogService
      .selectEntity<FireAlarmComponentDto>(
        SelectFireAlarmComponentDialogComponent
      )
      .afterClosed()
      .subscribe((item) => {
        if (item) {
          const fireAlarmComponent: FireAlarmSystemComponent =
            new FireAlarmSystemComponent({
              manufacture: item.manufacture,
              model: item.model,
              type: item.type
            });
          this.fireAlarmComponents = [
            ...this.fireAlarmComponents,
            fireAlarmComponent
          ];

          this.onChange();
        }
      });
  }

  remove(fireAlarmComponent: FireAlarmSystemComponentDto): void {
    const index = this.fireAlarmComponents.indexOf(fireAlarmComponent);
    this.fireAlarmComponents.splice(index, 1);
    this.fireAlarmComponents = [...this.fireAlarmComponents];
    this.onChange();
  }

  onChange(): void {
    this.dataChange.emit(this.fireAlarmComponents);
  }
}
